<template>
    <b-form inline>
        <label class="mr-sm-2">Ano</label>
        <b-form-select :plain="true" :options="anos" v-model="anoSelecionado"></b-form-select>
    </b-form>
</template>

<script>
export default {
	props: {
		value: {
			type: Number
		}
	},

	data() {
		return {
			anos: [],
			anoSelecionado: 0
		}
	},

	created() {
		this.anoSelecionado = this.value
		let ano = new Date().getFullYear()
		this.anos[0] = ano
		for (let index = 1; index < 5; index++) {
			this.anos[index] = ano - index
		}
	},

	watch: {
		anoSelecionado() {
			this.$emit('input', this.anoSelecionado)
		}
	}
}
</script>
